// Personas reference men's-health investment doc §THE SOLUTION.
//
// IDs are STABLE, BACKEND-FACING identifiers. Canonical three:
// executive | professional | tradesman.
//
// Frontend surfaces all three with first-name-style display names so callers
// feel like they're picking a person, not an archetype:
//   tradesman    → "Jose M."     (hands-on)
//   executive    → "Collin H."   (leader / time-conscious)
//   professional → "Allen P."    (engineer / maker / founder)
//
// The 'climber' backend id is retained as an alias of 'professional' for
// any in-flight client (MP events, v02 PERSONA_NAMES, persona_voices rows
// keyed by 'climber') during migration. The 'wrangler' persona has been
// retired — its terms folded into 'tradesman'.
import { HardHat, Briefcase, Wrench } from 'lucide-react';

// 10 short ElevenLabs intros per persona, played from the card's play-button.
// First click is the canonical hello; each subsequent click cycles to the next
// nudge (counter persisted in sessionStorage so it survives re-renders).
// Source-of-truth scripts live at app/scripts/persona-audio-scripts.json;
// regenerate with: ELEVENLABS_API_KEY=… node app/scripts/generate-persona-audio.mjs
const AUDIO_CLIP_COUNT = 10;
function audioClips(personaId) {
  return Array.from({ length: AUDIO_CLIP_COUNT }, (_, i) =>
    `/personas/audio/${personaId}/${String(i + 1).padStart(2, '0')}.mp3`
  );
}

export const PERSONAS = [
  {
    id: 'tradesman',
    name: 'Jose M.',
    tagline: 'Hard work. Straight talk.',
    blurb:
      "For the man who works with his hands. No pitch, no fluff — just answers.",
    cta: "Let's talk now.",
    image: '/personas/tradesman.jpg',
    icon: HardHat,
    accent: 'from-amber-800/50 to-stone-950',
    ring: 'ring-amber-500',
    voice: 'tradesman_en',
    // Custom voice picked by Brian.
    voiceId: '86ZLAUcyPNBrbdJKn3u6',
    audioClips: audioClips('tradesman')
  },
  {
    id: 'executive',
    name: 'Collin H.',
    tagline: 'Sharp mind. Respects your time.',
    blurb:
      'For the man leading teams and families. Private, efficient, built around your schedule.',
    cta: "I've got a minute.",
    image: '/personas/executive.jpg',
    icon: Briefcase,
    accent: 'from-slate-700/60 to-stone-950',
    ring: 'ring-slate-400',
    voice: 'executive_en',
    // Custom voice picked by Brian.
    voiceId: 'Cz0K1kOv9tD8l0b5Qu53',
    audioClips: audioClips('executive')
  },
  {
    id: 'professional',
    name: 'Allen P.',
    tagline: 'Engineer. Maker. Operator.',
    blurb:
      'For the man who thinks in systems. Curious, direct, no hype.',
    cta: "Let's dig in.",
    // Asset paths still use 'climber' on disk — switch when the assets
    // are renamed. (See app/public/personas/ + app/scripts/persona-audio-scripts.json.)
    image: '/personas/climber.jpg',
    icon: Wrench,
    accent: 'from-emerald-800/55 to-stone-950',
    ring: 'ring-emerald-500',
    voice: 'professional_en',
    // Custom voice picked by Brian (faster than the previous ewx… voice).
    voiceId: 'nJvj5shg2xu1GKGxqfkE',
    audioClips: audioClips('climber')
  }
];

export function findPersona(id) {
  return PERSONAS.find((p) => p.id === id) || null;
}
